// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,
    cognito: {
        userPoolId: 'ap-southeast-2_DluVFPazj',
        userPoolWebClientId: '2qi4mf42gbloshmbkkpp12omi0',
    },
    api: {
        //dev
        endpoint: 'https://5hj7n8zqu5.execute-api.ap-southeast-2.amazonaws.com/dev/api',
        hubUrl: 'https://5hj7n8zqu5.execute-api.ap-southeast-2.amazonaws.com/dev/socket',

        //adung
        // endpoint: 'http://localhost:5000/api',
        // hubUrl: 'http://localhost:5000/socket',
        socketServer: 'wss://d9kij57no3.execute-api.ap-southeast-2.amazonaws.com/dev',
    },
    elasticAPM: {
        serviceName: '',
        serverUrl: '',
        distributedTracingOrigins: [],
        transactionName: 'Transaction-Name',
        sensitiveParamNames: ['password', 'currentPassword', 'newPassword', 'confirmPassword'],
    },
    enableLogging: false,
    findOutMoreUrl: 'https://techvify.com.vn/',
    enableIomTermsAndConditions: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
